import http from 'http'
import server from 'src/utils/server'

export const getContracts = (params) => {
  return http.get(server.url_to('contracts/?' + params))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getSetting = (params) => {
  return http.get(server.url_to('contracts/' + params.id + '/show_setting_by_tag/' + params.setting_tag))
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}

export const updateSetting = (params) => {
  return http.post(server.url_to('contracts/' + params.id + '/update_setting_by_tag/' + params.setting_tag), params)
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}

export const getContractsCsv = (params) => {
  return http.get(server.url_to('contracts.csv/?' + params))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getContract = (id) => {
  return http.get(server.url_to('contracts/' + id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const createNextInvoice = (id) => {
  return http.post(server.url_to('contracts/' + id + '/generate_next_invoice'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getContractPlan = (id) => {
  return http.get(server.url_to('contract_plans/' + id))
    .then((response) => {
      return response
    })
  .catch(function (error) {
    return error.response
  })
}

export const updateContract = (params) => {
  return http.put(server.url_to('contracts/' + params.contract_id + '/contract_plans/' + params.contract_plans_id), params.body)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const captureLogs = (params) => {
  return http.get(server.url_to('logs/' + params.entity + '/' + params.id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const editContract = (params) => {
  return http.put(server.url_to('contracts/' + params.id), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const destroyContract = (contract) => {
  return http.delete(server.url_to('contracts/' + contract.id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const newContract = (params) => {
  return http.post(server.url_to('contracts/complete'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const cancelDebit = (contract) => {
  return http.put(server.url_to('contracts/' + contract.id + '/inactivate_debit'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const setTax = (params) => {
  return http.post(server.url_to('contracts/' + params.contract_id + '/contract_taxes'), params)
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}

export const inactivateContractTax = (params) => {
  return http.delete(server.url_to('contracts/' + params.contract_id + '/contract_taxes/' + params.contract_tax_id))
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}




// WEBPACK FOOTER //
// ./src/app/pages/contracts/services.js